import React from 'react';
export default function ChevronDownDesignIcon() {
    return (React.createElement("div", { className: 'revamp-chevron-icon' },
        React.createElement("svg", { fill: 'none', preserveAspectRatio: 'none', viewBox: '0 0 8 5' },
            React.createElement("path", { d: 'M1 1L4 4L7 1', stroke: '#6E6E77', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.5' }))));
}
